import { render, staticRenderFns } from "./detailBoxofficeRecord.vue?vue&type=template&id=78ac0848&scoped=true&"
import script from "./detailBoxofficeRecord.vue?vue&type=script&lang=js&"
export * from "./detailBoxofficeRecord.vue?vue&type=script&lang=js&"
import style0 from "./detailBoxofficeRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailBoxofficeRecord.vue?vue&type=style&index=1&id=78ac0848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ac0848",
  null
  
)

export default component.exports